import React from 'react'

const DialogChangeBranchCoordinatorError = () => {
  return (
    <div>
      <p className="mb-4">
        Este rol te permite gestionar usuarios y formularios dentro de la sede que tienes asignada.
      </p>
      <p>
        Si te quitas este rol, ya no podrás:
        <ul className="list-disc ml-4 mb-4">
          <li>Crear o editar usuarios de sede</li>
          <li>Asignar formularios en tu sede</li>
          <li>Recuperar tu acceso como coordinador sin ayuda</li>
        </ul>
      </p>
      <p>
        Solo un coordinador de entidad podrá devolverte el rol. Asegúrate de que haya uno activo en tu entidad antes de
        continuar.
      </p>
    </div>
  )
}

export default DialogChangeBranchCoordinatorError
